import { Button } from '@chakra-ui/button';
import { Tooltip } from '@chakra-ui/react';
import * as React from 'react';

import { AggregateInvitationStatusForUsersV3Input } from '@/graphql-types/globalTypes';
import { ISelectionState } from '@/imports/ui/useSelectionState';

import { IUsersQueryState, queryStateToFilter } from '../../../usersQueryState';
import { Member_UserFragment } from '../Member/graphql-types/Member_UserFragment';
import { MembersInviteModal } from './MembersInviteModal';

type IBulkInviteButtonProps = {
  selection: ISelectionState<Member_UserFragment>;
  queryState: IUsersQueryState;
  isLoadingSearch: boolean;
};

export const BulkInviteButton: React.FC<IBulkInviteButtonProps> = ({
  selection,
  queryState,
  isLoadingSearch,
}) => {
  const [inviteModalOpen, setInviteModalOpen] = React.useState(false);
  const userSelection: AggregateInvitationStatusForUsersV3Input =
    isLoadingSearch
      ? { filter: {} }
      : selection.allSelected
      ? {
          filter: {
            ...queryStateToFilter(queryState),
            excludeUserIds: selection.excludedItems.map((item) => item._id),
          },
        }
      : { userIds: selection.includedItems.map((item) => item._id) };

  const itemsAreSelected =
    ('includedItems' in selection && selection.includedItems.length > 0) ||
    selection.allSelected;

  const eligableUsersExistInSelection = !isLoadingSearch && itemsAreSelected;

  const tooltipLabel = eligableUsersExistInSelection
    ? ''
    : !selection.allSelected && selection.includedItems.length === 0
    ? 'No one has been selected yet'
    : 'No one you selected is eligible to be invited';

  return (
    <>
      {inviteModalOpen && (
        <MembersInviteModal
          usersSelection={userSelection}
          onClose={() => setInviteModalOpen(false)}
        />
      )}
      <Tooltip
        isDisabled={eligableUsersExistInSelection}
        placement="top"
        label={tooltipLabel}
        hasArrow
        closeDelay={500}
        shouldWrapChildren // https://github.com/chakra-ui/chakra-ui/issues/500
      >
        <Button
          isDisabled={!eligableUsersExistInSelection}
          onClick={() => setInviteModalOpen(true)}
        >
          Bulk Invite
        </Button>
      </Tooltip>
    </>
  );
};
